import { ContentHubArticlePageBlockProps } from "../../ContentHubArticlePageBlock"

export const filterArticles = (
	articles: ContentHubArticlePageBlockProps[],
	filterItem: string
) =>
	articles.filter((article) =>
		article.categories.value.some(
			(category) => category.description === filterItem
		)
	)
